'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _commonicdchangesbydrg = require('./commonicdchangesbydrg.component');

var _commonicdchangesbydrg2 = _interopRequireDefault(_commonicdchangesbydrg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonicdchangesbydrgModule = _angular2.default.module('commonicdchangesbydrg', [_angularUiRouter2.default]).component('commonicdchangesbydrg', _commonicdchangesbydrg2.default);

exports.default = commonicdchangesbydrgModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchangesbydrg/commonicdchangesbydrg.js